export class ProviderModel {
  id: number;
  cod: string;
  description: string;
  checked: boolean;
  lastUploadedBilling: number;

  lastConsolidatedMonth: number;
  lastMonth: number;
  lastUploadedCharging: number;
  lastUploadedVolume: number;


  constructor(id?: number, cod?: string, description?: string, checked?: boolean) {
    this.cod = cod;
    this.id = id;
    this.description = description;
    this.checked = checked;

  }
}
